<div class="sub-menu-root-container payroll-menu-root-container"
    [style.width]="show ? 'var(--left-side-optionbar-width)' : '25px'">
    <div class="menu-list-container">
        <!-- Masters List -->


        <mat-list-item *ngIf="userData?.user_type === 'HQ' && hasAccess('payroll-group')" class="mat-list-item"
            routerLink="/payroll/payroll-group" [routerLinkActive]="['is-active']"
            [matTooltip]="!show ? 'Payroll Group' : ''" matTooltipPosition="right" matTooltipClass="mat-tooltip">
            <div class="mat-list-item-contents">
                <img src="assets/images/menu/svg/payroll-group.svg">
                <span class="master-title"> Payroll Group
                </span>
            </div>
        </mat-list-item>
        <mat-list-item *ngIf="userData?.user_type === 'HQ' && hasAccess('shop-payroll-setting')" class="mat-list-item"
            routerLink="/payroll/shop-payroll-setting" [routerLinkActive]="['is-active']" (click)="resetState()"
            [matTooltip]="!show ? 'Shop Payroll' : ''" matTooltipPosition="right" matTooltipClass="mat-tooltip">
            <div class="mat-list-item-contents">
                <img src="assets/images/menu/svg/shop-payroll.svg">
                <span class="master-title">Shop Payroll</span>
            </div>
        </mat-list-item>
        <mat-list-item class="mat-list-item" *ngIf="userData?.user_type === 'HQ'"
            routerLink="/payroll/staff-payroll-group" [routerLinkActive]="['is-active']" (click)="resetState()"
            [matTooltip]="!show ? 'Staff Payroll' : ''" matTooltipPosition="right" matTooltipClass="mat-tooltip">
            <div class="mat-list-item-contents">
                <img src="assets/images/menu/svg/staff-payroll.svg">
                <span class="master-title">Staff Payroll
                </span>
            </div>
        </mat-list-item>

        <mat-list-item class="mat-list-item"
            *ngIf="userData?.user_type === 'HQ' && hasAccess('payroll-attendance-export')"
            routerLink="/payroll/payroll-attendance-export" [routerLinkActive]="['is-active']" (click)="resetState()"
            [matTooltip]="!show ? 'Attendance' : ''" matTooltipPosition="right" matTooltipClass="mat-tooltip">
            <div class="mat-list-item-contents">
                <img src="assets/images/menu/svg/attendence-export.svg">
                <span class="master-title">Attendance
                </span>
            </div>
        </mat-list-item>

        <mat-list-item class="mat-list-item" *ngIf="userData?.user_type === 'SHOP' && hasAccess('staff-attendance')"
            routerLink="/employee/staff-attendance" [routerLinkActive]="['is-active']" (click)="resetState()"
            [matTooltip]="!show ? 'Staff Attendance' : ''" matTooltipPosition="right" matTooltipClass="mat-tooltip">
            <div class="mat-list-item-contents">
                <img src="assets/images/menu/svg/payroll-attendence-export.svg">
                <span class="master-title">Staff Attendance
                </span>
            </div>
        </mat-list-item>


    </div>
</div>